export const aboutData = {
  brandName: "韩漫在线",
  tagline: "随时随地，畅享韩国漫画的无限精彩",
  introduction:
    "韩漫在线成立于2023年，是国内领先的韩国漫画在线阅读平台。我们致力于为中国读者提供最全面、最新鲜、最高质量的韩漫阅读体验。平台汇聚了数百部精品韩国漫画，涵盖恋爱、奇幻、动作、悬疑、搞笑、日常等多种类型，满足不同读者的多样化需求。",
  mission:
    "我们的使命是打破语言和地域的界限，将韩国优秀的漫画作品带给每一位热爱漫画的中国读者。通过专业的翻译团队和精良的制作工艺，让每一部作品都能以最佳的状态呈现在读者面前。",
  features: [
    {
      title: "正版授权",
      description: "与韩国多家知名漫画平台和出版社建立合作，确保所有作品均为正版授权内容，让读者放心阅读。",
      icon: "ri-shield-check-line",
    },
    {
      title: "更新迅速",
      description: "专业的翻译和制作团队全天候待命，确保热门作品能够在第一时间更新，让读者不落后于韩国进度。",
      icon: "ri-flashlight-line",
    },
    {
      title: "分类齐全",
      description: "涵盖恋爱、奇幻、动作、悬疑、搞笑、日常、耽美、穿越等十余种分类，总有你喜欢的类型。",
      icon: "ri-grid-line",
    },
    {
      title: "阅读体验",
      description: "精心优化的阅读界面，支持多种阅读模式，让沉浸式阅读成为一种享受。",
      icon: "ri-book-open-line",
    },
  ],
  stats: [
    { value: "500+", label: "精品漫画" },
    { value: "10万+", label: "日活跃用户" },
    { value: "1000万+", label: "累计阅读量" },
    { value: "98%", label: "用户好评率" },
  ],
  reviews: [
    {
      name: "小雨",
      avatar: "https://readdy.ai/api/search-image?query=A%20simple%20cute%20anime%20style%20girl%20avatar%20with%20pink%20background%2C%20simple%20design%2C%20clean%20flat%20illustration&width=100&height=100&seq=avatar-01&orientation=squarish",
      rating: 5,
      comment: "韩漫在线真的是我目前用过最好的漫画阅读平台！更新速度超快，翻译质量也很棒，推荐给所有喜欢韩漫的朋友！",
      date: "2026-07-15",
    },
    {
      name: "星辰大海",
      avatar: "https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20boy%20avatar%20with%20blue%20background%2C%20simple%20design%2C%20clean%20flat%20illustration&width=100&height=100&seq=avatar-02&orientation=squarish",
      rating: 5,
      comment: "分类非常清晰，找漫画很方便。每天都有新作品更新，完全满足了我的阅读需求。已经推荐给身边的朋友了！",
      date: "2026-07-10",
    },
    {
      name: "樱花落",
      avatar: "https://readdy.ai/api/search-image?query=A%20simple%20cute%20anime%20style%20girl%20avatar%20with%20soft%20purple%20background%2C%20simple%20design%2C%20clean%20flat%20illustration&width=100&height=100&seq=avatar-03&orientation=squarish",
      rating: 4,
      comment: "界面设计很清爽，阅读体验很流畅。希望能增加更多完结作品，追更等得太辛苦了哈哈！",
      date: "2026-07-05",
    },
    {
      name: "追风少年",
      avatar: "https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20boy%20avatar%20with%20green%20background%2C%20simple%20design%2C%20clean%20flat%20illustration&width=100&height=100&seq=avatar-04&orientation=squarish",
      rating: 5,
      comment: "作为一个韩漫老粉，这个网站真的让我很惊喜。作品库很全，翻译也很用心，已经成为了我每天必刷的网站。",
      date: "2026-06-28",
    },
  ],
  contact: {
    email: "contact@hanmanonline.com",
    wechat: "韩漫在线官方",
    weibo: "@韩漫在线",
    qq: "1234567890",
    address: "北京市朝阳区望京SOHO塔3-B座",
    workingHours: "周一至周五 9:00 - 18:00",
  },
  faqs: [
    {
      question: "韩漫在线的漫画都是免费的吗？",
      answer: "是的！韩漫在线上所有漫画均可免费在线阅读。我们致力于为读者提供高质量的免费韩漫阅读体验，让每一位漫画爱好者都能畅享精彩故事。",
    },
    {
      question: "漫画的更新频率是怎样的？",
      answer: "热门漫画通常每周更新1-2话，部分作品可能因韩国方面的连载进度有所调整。我们会在首页和作品详情页及时公布最新的更新信息，方便读者追更。",
    },
    {
      question: "支持哪些设备阅读？",
      answer: "韩漫在线支持PC端网页、手机端网页以及平板端网页阅读。您可以在任何设备上通过浏览器访问我们的网站，随时随地享受阅读乐趣。",
    },
    {
      question: "如何快速找到我想看的漫画？",
      answer: "您可以通过首页的分类导航、搜索功能或热门排行来快速找到感兴趣的漫画。我们提供恋爱、奇幻、动作、悬疑等多种分类筛选，帮助您精准定位喜欢的作品类型。",
    },
    {
      question: "漫画的翻译质量如何保证？",
      answer: "我们拥有专业的韩语翻译团队，每位翻译人员都经过严格的筛选和培训。所有作品在上线前都会经过翻译、校对、排版等多次质量审核，确保为读者提供准确、流畅的阅读体验。",
    },
  ],
};